(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/start/assets/react/start-page.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/start/assets/react/start-page.js');

'use strict';

const {
  FullscreenWidgetProvider
} = svs.eurojackpot.react.context;
const {
  HeaderText,
  PlayButtons,
  HowToLink,
  NavigationButtons,
  PlayOwnButton,
  FullscreenWidget
} = svs.eurojackpot.react.components;
const StartPage = () => React.createElement(FullscreenWidgetProvider, null, React.createElement("div", {
  className: "eurojackpot-start-page-container"
}, React.createElement("div", {
  className: "eurojackpot-start-page-main-content"
}, React.createElement("div", null, React.createElement(HeaderText, null), React.createElement(PlayOwnButton, null), React.createElement(PlayButtons, null)), React.createElement(HowToLink, null)), React.createElement(NavigationButtons, null), React.createElement(FullscreenWidget, null)));
const rootEl = document.getElementById('ngStartPageRegion');
if (rootEl) {
  ReactDOM.render(React.createElement(StartPage, null), rootEl);
}

 })(window);